export const HOST = "https://api.ryletd.ru";
// export const HOST = "http://localhost:5500";

export const ENDPOINTS = {
    // Endpoints для рецептов
    RECIPES_ENDPOINT: "/recipes",
    RECIPE_ENDPOINT: "/recipe",
};
